<template>
  <div class="generic">
    <Headline>{{ teachingColloquia.headLine }}</Headline>

    <BlueBox
      v-bind:headline="teachingColloquia.content.blueBox.headLine"
      img=""
    >
      {{ teachingColloquia.content.blueBox.content[0] }}
      <br /><br />
      {{ teachingColloquia.content.blueBox.content[1] }}
    </BlueBox>

    <ContentBox
      v-if="hasEvents(events('W26'), 'colloquium')"
      headline="Winter Term 2025/2026"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W26')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S25'), 'colloquium')"
      headline="Summer Term 2025"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S25')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W25'), 'colloquium')"
      headline="Winter Term 2024/2025"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W25')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S24'), 'colloquium')"
      headline="Summer Term 2024"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S24')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W24'), 'colloquium')"
      headline="Winter Term 2023/2024"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W24')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S23'), 'colloquium')"
      headline="Summer Term 2023"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S23')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W23'), 'colloquium')"
      headline="Winter Term 2022/2023"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W23')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S22'), 'colloquium')"
      headline="Summer Term 2022"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S22')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W22'), 'colloquium')"
      headline="Winter Term 2021/2022"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W22')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S21'), 'colloquium')"
      headline="Summer Term 2021"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S21')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W21'), 'colloquium')"
      headline="Winter Term 2020/2021"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W21')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S20'), 'colloquium')"
      headline="Summer Term 2020"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S20')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W20'), 'colloquium')"
      headline="Winter Term 2019/2020"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W20')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S19'), 'colloquium')"
      headline="Summer Term 2019"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S19')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('W18'), 'colloquium')"
      headline="Winter Term 2018/2019"
    >
      <b-row
        class="event-row"
        v-for="entry in events('W18')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>
    <ContentBox
      v-if="hasEvents(events('S18'), 'colloquium')"
      headline="Summer Term 2018"
    >
      <b-row
        class="event-row"
        v-for="entry in events('S18')"
        :key="entry.name + entry.date"
      >
        <b-col
          md="2"
          cols="12"
          class="event-type-column"
          v-if="entry.type == 'colloquium'"
          >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
            cropDate(entry.date, 1)
          }}</b-col
        >
        <b-col
          md="10"
          class="event-name-column"
          v-if="entry.type == 'colloquium'"
          >{{ entry.name }}</b-col
        >
      </b-row>
    </ContentBox>

    <div class="generic" id="workshops">
      <Headline>Workshops</Headline>
      <ContentBox
        v-if="hasEvents(events('W26'), 'workshop')"
        headline="Winter Term 2025/2026"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W26')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W25'), 'workshop')"
        headline="Winter Term 2024/2025"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W25')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S24'), 'workshop')"
        headline="Summer Term 2024"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S24')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W24'), 'workshop')"
        headline="Winter Term 2023/2024"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W24')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S23'), 'workshop')"
        headline="Summer Term 2023"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S23')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W23'), 'workshop')"
        headline="Winter Term 2022/2023"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W23')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S22'), 'workshop')"
        headline="Summer Term 2022"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S22')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W22'), 'workshop')"
        headline="Winter Term 2021/2022"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W22')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S21'), 'workshop')"
        headline="Summer Term 2021"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S21')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W21'), 'workshop')"
        headline="Winter Term 2020/2021"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W21')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S20'), 'workshop')"
        headline="Summer Term 2020"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S20')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W20'), 'workshop')"
        headline="Winter Term 2019/2020"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W20')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S19'), 'workshop')"
        headline="Summer Term 2019"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S19')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W18'), 'workshop')"
        headline="Winter Term 2018/2019"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W18')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S18'), 'workshop')"
        headline="Summer Term 2018"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S18')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'workshop'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'workshop'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
    </div>

    <div class="generic">
      <Headline>External lectures</Headline>
      <ContentBox
        v-if="hasEvents(events('W25'), 'external')"
        headline="Winter Term 2024/2025"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W25')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S24'), 'external')"
        headline="Summer Term 2024"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S24')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W24'), 'external')"
        headline="Winter Term 2023/2024"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W24')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S23'), 'external')"
        headline="Summer Term 2023"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S23')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W23'), 'external')"
        headline="Winter Term 2022/2023"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W23')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S22'), 'external')"
        headline="Summer Term 2022"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S22')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W22'), 'external')"
        headline="Winter Term 2021/2022"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W22')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S21'), 'external')"
        headline="Summer Term 2021"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S21')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W21'), 'external')"
        headline="Winter Term 2020/2021"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W21')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S20'), 'external')"
        headline="Summer Term 2020"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S20')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W20'), 'external')"
        headline="Winter Term 2019/2020"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W20')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S19'), 'external')"
        headline="Summer Term 2019"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S19')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('W18'), 'external')"
        headline="Winter Term 2018/2019"
      >
        <b-row
          class="event-row"
          v-for="entry in events('W18')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
      <ContentBox
        v-if="hasEvents(events('S18'), 'external')"
        headline="Summer Term 2018"
      >
        <b-row
          class="event-row"
          v-for="entry in events('S18')"
          :key="entry.name + entry.date"
        >
          <b-col
            md="2"
            cols="12"
            class="event-type-column"
            v-if="entry.type == 'external'"
            >{{ cropDate(entry.date, 0) }} <br />&nbsp&nbsp{{
              cropDate(entry.date, 1)
            }}</b-col
          >
          <b-col
            md="10"
            class="event-name-column"
            v-if="entry.type == 'external'"
            >{{ entry.name }}</b-col
          >
        </b-row>
      </ContentBox>
    </div>
  </div>
</template>

<script>
import ContentBox from "@/components/ContentBox.vue";
import BlueBox from "@/components/BlueBox.vue";
import Headline from "@/components/Headline.vue";

export default {
  name: "ColloqiuaPage",
  props: {
    // will be set by router
    metaProp: Object,
  },
  // vue-head meta info
  metaInfo() {
    return this.metaProp;
  },
  components: {
    ContentBox,
    BlueBox,
    Headline,
  },
  methods: {
    events(selector) {
      return this.$store.state.data.colloquiaEvents.filter((entry) =>
        entry.semester.includes(selector),
      );
    },
    cropDate(date, index) {
      //return date.substring(index, date.indexOf(' '));
      var arr = date.split(/ (.*)/);
      return arr[index];
    },
    hasEvents(semester, type) {
      for (let i = 0; i < semester.length; i++) {
        if (semester[i].type === type) {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    teachingColloquia: function () {
      return this.$store.state.data.teachingColloquia;
    },
  },
  created() {
    this.$store.dispatch("fetchData", {
      url: "https://raw.githubusercontent.com/css-lab-rwth/csslab-web-content/master/data/colloquiaEvents.json",
      dir: "colloquiaEvents",
    });
    this.$store.dispatch("fetchData", {
      url: "https://raw.githubusercontent.com/css-lab-rwth/csslab-web-content/master/data/teachingColloquia.json",
      dir: "teachingColloquia",
    });
  },
};
</script>

<style scoped>
.generic {
  padding-bottom: 50px;
}
.event-row {
  margin-left: 0px;
}
.event-name-column {
  padding-bottom: 5px;
  padding-left: 0px;
}
.event-type-column {
  padding-right: 0px;
}
.event-type-column:before {
  content: "";
  border-color: transparent rgb(0, 84, 159);
  border-style: solid;
  border-width: 0.35em 0 0.35em 0.45em;
  display: inline-block;
  left: -0.5em;
  position: relative;
}
@media screen and (max-width: 768px) {
  .event-name-column {
    padding-bottom: 15px;
    margin-left: 1.5em;
  }
}
</style>
